import type { FC } from "react";
import { Icon } from "../UI/Icon";

interface InfoIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export const InfoIcon: FC<InfoIconProps> = (props) => (
  <Icon {...props} variant="outline">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
    <path
      d="M12 16V12M12 8H12.01"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
